import { useCreateOperator } from '../../../../contexts/CreateOperatorContext';
import { Divider } from '../../../../components/Divider';
import { SettingRow } from '../../../Manage/Operator/Settings/SettingRow';
import { SettingTag } from '../SettingTag';
import React from 'react';
import { BranchSelect } from './BranchSelect';
import { useSort } from '../../../../hooks/useSort';

export const MediaroomRequired = () => {
  const { operator } = useCreateOperator();
  const { sortAsc } = useSort<{ order: number }>('order');

  if (operator.mediaRoomSettings === undefined) return null;

  const settings: SettingRowConfig[] = [
    {
      order: 1,
      component: <BranchSelect />,
      icon: <SettingTag name="Mediaroom" color="violet" size="sm" />,
      title: 'Branch',
      level: 'sub',
      show: true,
    },
  ];

  const renderDivider = (index: number) => {
    if (index + 1 === settings.filter((setting) => setting.show).length) return;
    return <Divider />;
  };

  return (
    <>
      {settings
        .filter((setting) => setting.show)
        .sort(sortAsc)
        .map((setting, index) => (
          <React.Fragment key={`operator-account-setting-${index + 1}`}>
            <SettingRow
              title={setting.title}
              description={setting.description}
              icon={setting.icon}
              level={setting.level}
            >
              {setting.component}
            </SettingRow>
            {renderDivider(index)}
          </React.Fragment>
        ))}
    </>
  );
};
